@if (step>0) {
  <mat-icon class="tuto-button" style="left:50px;" (click)="next_step()">arrow_right</mat-icon>
  <mat-icon class="tuto-button" style="left:100px;" (click)="close_tuto()">close</mat-icon>
  @if (image=="") {
    <div class="fullscreen" (keydown)="next_step()" (click)="next_step()"  >
      <div class="tuto-text">{{currentText}}</div>
    </div>

    <div class="tuto-container" (keydown)="next_step()" (click)="next_step()"
         [style.top]="top+'px'" [style.left]="left+'px'">
      <div class="tuto-background" [style.width]="width+'px'" [style.height]="height+'px'">
      </div>
    </div>
  } @else {
    <div class="fullscreen" style="background: black;" (keydown)="next_step()" (click)="next_step()">
      <img [src]="image" style="height: 100%;" alt="Tutoriel" >
    </div>
  }
} @else {
  @if (!autostart) {
    @if (small) {
      <mat-icon style="font-size: small" (click)="start_tuto()">help</mat-icon>
    } @else {
      <button mat-icon-button (click)="start_tuto()">
        <mat-icon>help</mat-icon>
      </button>
    }
  }

}


